/**
 * TanStack Query hooks for `fraud-report-slicing-campaign-publisher-geo-device`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudReportSlicingCampaignPublisherGeoDeviceQueryKeys,
	type CreateFraudReportSlicingCampaignPublisherGeoDeviceBody,
	type ListFraudReportSlicingCampaignPublisherGeoDeviceResponse,
	type FraudReportSlicingCampaignPublisherGeoDeviceRow,
} from "./api";

export function useFraudReportSlicingCampaignPublisherGeoDeviceList(): UseQueryResult<ListFraudReportSlicingCampaignPublisherGeoDeviceResponse, Error> {
	return useQuery({
		queryKey: fraudReportSlicingCampaignPublisherGeoDeviceQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudReportSlicingCampaignPublisherGeoDeviceCreate(): UseMutationResult<FraudReportSlicingCampaignPublisherGeoDeviceRow, Error, CreateFraudReportSlicingCampaignPublisherGeoDeviceBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudReportSlicingCampaignPublisherGeoDeviceQueryKeys.all });
		},
	});
}

export function useFraudReportSlicingCampaignPublisherGeoDeviceDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudReportSlicingCampaignPublisherGeoDeviceQueryKeys.all });
		},
	});
}
